module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_21.57ad8141.pdf";